import './index.css'

const Images = props => {
  const {imagesList, onClickImage} = props
  const {id, thumbnailUrl} = imagesList
  const onClickImg = () => {
    onClickImage(id)
  }
  return (
    <li className="liContainer">
      <button type="button" className="btn" onClick={onClickImg}>
        <img className="image" src={thumbnailUrl} alt="thumbnail" />
      </button>
    </li>
  )
}
export default Images
